import { render, staticRenderFns } from "./FileIcon.vue?vue&type=template&id=c0cd4140&scoped=true&"
import script from "./FileIcon.vue?vue&type=script&lang=js&"
export * from "./FileIcon.vue?vue&type=script&lang=js&"
import style0 from "./FileIcon.vue?vue&type=style&index=0&id=c0cd4140&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0cd4140",
  null
  
)

export default component.exports